import {
	SET_FORM_STATE,
	GET_COSITE_HEALTHCHECK_TABLE,
	GET_NBRRELATIONS_LAST_UPDATE
} from '../actions/CositeHealthCheckActions';

const initialState = {
	formState: {
		values: {},
		isValid: false,
		touched: {},
		errors: {},
		submit: false
	},
	cositeHealthCheckData: [],
	nbrRelationsLastUpdate: ''
};

const cositeHealthCheckReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					case GET_COSITE_HEALTHCHECK_TABLE: {
						return {
							...state,
							cositeHealthCheckData: action.cositeHealthCheckData
						};
					}
					case GET_NBRRELATIONS_LAST_UPDATE: {
						return {
							...state,
							nbrRelationsLastUpdate: action.nbrRelationsLastUpdate
						};
					}
					default: {
						return state;
					}
	}
};

export default cositeHealthCheckReducer;
